/* eslint-disable no-unneeded-ternary */
import PropTypes from "prop-types";
import React, { memo } from "react";
import ContactSales from "../ContactSales";
import Icon from "../Icon";
import "./GetStarted.scss";
import "../../styles/globalStyles.scss";
import Conditional from "../../hocs/Conditional";

function getUTMLink(baseLink, sourceAction, utmAppend) {
  return sourceAction.length > 0
    ? `${baseLink}${sourceAction}&${utmAppend}`
    : `${baseLink}${utmAppend}`;
}

const GetStarted = ({
  heading,
  content,
  checkList,
  startNowBaseLink,
  getInTouchBaseLink,
  startNowLinkUtmAppend,
  getInTouchLinkUtmAppend,
  utmSourceAction = "",
  contactSalesCTAVisible,
  createAccountCTAName,
  cta,
}) => (
  <section className="get-started">
    <div className="container position-relative" style={{ zIndex: "1" }}>
      <div className="row row-no-margin jistify-flex-start tablet-wrap">
        <div className="column" style={{ padding: 0 }}>
          <h2>{heading}</h2>
          <p className="md:!max-w-[650px]">{content}</p>
          <ul className="check-list-round">
            {checkList?.map(({ id, listItem, listitem }) => (
              <li key={id}>
                <span>
                  <Icon
                    name="tick"
                    width="9.21px"
                    height="6.29px"
                    fill="#fff"
                  />
                </span>
                <p>{listItem || listitem}</p>
              </li>
            ))}
          </ul>
        </div>
        <div className="row row-no-margin buttons">
          <Conditional if={cta?.length > 0}>
            <a
              href={cta?.[0]?.link}
              rel="noopener noreferrer"
              className="button button-green">
              {cta?.[0]?.label}
              <span className="chevron" />
            </a>
            {contactSalesCTAVisible && (
              <ContactSales
                href={cta?.[1]?.link}
                rel="noopener noreferrer"
                className="button button-outline no-shadow">
                {cta?.[1]?.label}
                <span className="chevron" />
              </ContactSales>
            )}
          </Conditional>
          <Conditional if={cta == null || cta?.length === 0}>
            <a
              href={getUTMLink(
                startNowBaseLink,
                utmSourceAction,
                startNowLinkUtmAppend,
              )}
              rel="noopener noreferrer"
              className="button button-green">
              {createAccountCTAName ? createAccountCTAName : "Create Account"}

              <span className="chevron" />
            </a>
            {contactSalesCTAVisible && (
              <ContactSales
                href={getUTMLink(
                  getInTouchBaseLink,
                  utmSourceAction,
                  getInTouchLinkUtmAppend,
                )}
                rel="noopener noreferrer"
                className="button button-outline no-shadow">
                Contact Sales
                <span className="chevron" />
              </ContactSales>
            )}
          </Conditional>
        </div>
      </div>
    </div>
  </section>
);

GetStarted.propTypes = {
  heading: PropTypes.string,
  content: PropTypes.string,
  checkList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      btnColor: PropTypes.string,
    }),
  ),
  startNowBaseLink: PropTypes.string,
  getInTouchBaseLink: PropTypes.string,
  startNowLinkUtmAppend: PropTypes.string,
  getInTouchLinkUtmAppend: PropTypes.string,
  utmSourceAction: PropTypes.string,
  contactSalesCTAVisible: PropTypes.bool,
  createAccountCTAName: PropTypes.string,
  cta: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
  ),
};

GetStarted.defaultProps = {
  createAccountCTAName: "Create Account",
  contactSalesCTAVisible: true,
  utmSourceAction: "",
  heading: `Ready to get started?`,
  content: `Collect customer payments, make payouts, manage international payments and so much more. Create your account or contact our experts to explore custom solutions.`,
  checkList: [
    {
      id: 0,
      listItem: "Easy onboarding",
    },
    {
      id: 1,
      listItem: "Dedicated account manager",
    },
    {
      id: 2,
      listItem: "API access",
    },
  ],
  startNowBaseLink: "https://merchant.cashfree.com/merchants/signup?",
  getInTouchBaseLink: "/contact-sales?",
  startNowLinkUtmAppend: "action=Sign%20Up&button-id=StartNow_Footer",
  getInTouchLinkUtmAppend:
    "action=Contact%20Sales&button-id=ContactSales_Footer",
  cta: [],
};

export default memo(GetStarted);
